import React, {useCallback, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";
import {getTechnologyGroupByTime} from "../../../utils/TechnologyGroupUtils";
import ALink from "../../basics/alink/ALink";
import {makeGetTechnologyGroupSettings} from "../../../selectors/settingsSelector";
import {useSelector} from "react-redux";

export function GroupClickItem({
    TechnoGroupName,
    EvData: {InseminationTime = null} = {},
}) {
    const {t} = useTranslation();

    const history = useHistory();

    const getTechnologyGroupSettings = useMemo(
        () => makeGetTechnologyGroupSettings(),
        []
    );
    const technologyGroupSettings = useSelector(getTechnologyGroupSettings);

    const group = useMemo(() => {
        return getTechnologyGroupByTime(
            InseminationTime,
            technologyGroupSettings.start,
            technologyGroupSettings.weeks,
            technologyGroupSettings.method,
            technologyGroupSettings.years
        );
    }, [InseminationTime, technologyGroupSettings]);

    const text = `${t("technologyGroup")} ${TechnoGroupName}`;

    const onTechnoGroupClick = useCallback(() => {
        history.push({search: `?technologyGroup=${+group.start}`});
    }, [group, history]);

    if (!group) return null;
    return (
        <ALink uppercase={false} onClick={onTechnoGroupClick}>
            {text}
        </ALink>
    );
}
